import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { useApiMutation } from '@/modules/common';

import { CreateEventPayload } from '../types';

export function useCreateEvent() {
  const queryClient = useQueryClient();

  const createEventMutation = useApiMutation<CreateEventPayload>(
    '/events',
    {
      method: 'POST',
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['/events'] });
      },
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    createEventMutation,
  } as const;
}
